import React, { cloneElement } from "react";
import type { WidgetProps } from "@rjsf/utils";
import { spacing } from "../../../../../../../../stitches.config";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";

type BaseWidgetPreviewProps = WidgetProps & { children: React.JSX.Element };

export function BaseWidgetPreview({ children }: BaseWidgetPreviewProps) {
  return (
    <BuilderFieldWrapper>
      <div style={{ marginBottom: spacing.xs.toString() }}>
        {cloneElement(children, { isSubmissionBuilder: true })}
      </div>
    </BuilderFieldWrapper>
  );
}
